import { render } from "./BookingJoinView.vue?vue&type=template&id=f571fa0c&scoped=true&ts=true"
import script from "./BookingJoinView.vue?vue&type=script&lang=ts"
export * from "./BookingJoinView.vue?vue&type=script&lang=ts"

import "./BookingJoinView.vue?vue&type=style&index=0&id=f571fa0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f571fa0c"]])

export default __exports__